import type { ShopConfig } from 'domain-model/types/supplier-gateway';
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import NavBarVersion2 from './NavbarVersion2';
import NavBarVersion1 from './NavbarVersion1';

function NavBar({
  asPath,
  shopConfig,
}: {
  asPath: string;
  shopConfig: ShopConfig;
}) {
  const [scrollY, setScrollY] = useState(0);
  const isAtTopOfPage = scrollY < 100;
  const onScroll = useCallback(() => {
    setScrollY(window.scrollY);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);
  if (_.get(shopConfig, 'navbarConfig.version') === 'v2') {
    return <NavBarVersion2 asPath={asPath} isAtTopOfPage={isAtTopOfPage} />;
  }
  return <NavBarVersion1 asPath={asPath} isAtTopOfPage={isAtTopOfPage} />;
}
const mapStateToProps = ({ shopConfig }: { shopConfig: ShopConfig }) => ({
  shopConfig,
});
export default connect(mapStateToProps)(NavBar);
